import React, { useState } from "react";
import PropTypes from "prop-types";

import { LinkButton } from "../styled";
import { QuestionsAndContactComponent } from "../index";
import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck";
import { saniziteRawHtml } from "../../utils/Helpers";
import ReactHtmlParser from "react-html-parser";


export const AppleFitnessGetStartedComponent = (props) => {
  const [submissionPromoCode] = useState("CAMEOSPARK_PROMO_CODE");

  const initialValues = {
    phoneNumber: "",
  };

  const getButton =
    (promoCode, sectionText) =>
      ({ disabled, handleClick }) => {
        return (
          <>
            <div className="row text-center">
              {ReactHtmlParser(saniziteRawHtml(sectionText))}
            </div>
            <LinkButton
              className="btn"
              id="btnTfbContinue"
              href={process.env.REACT_APP_TMO_ID_AUTH_URL_DIGITAL}
              onClick={() => sessionStorage.setItem("promoCode", promoCode)}
              primary
            >
              Continue
            </LinkButton>
          </>
        );
      };

  const submitButtons = [
    getButton(props.cameosParkPromocode, props.firstSectionText),
    getButton(props.jazinFernoPromocode, props.secondSectionText),
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h2 className="magenta text-center">Let&rsquo;s start your Apple TV submission</h2>
            <p>Select your promotion below based on your rate plan. You will then be prompted to log into your account.</p>
            <p>T-Mobile postpaid consumer voice customers ready to add Apple TV,&nbsp;<strong><a href="https://www.t-mobile.com/account/benefit-redemption/appletvplus">click&nbsp;here</a></strong>&nbsp;to login and add your promotion.</p>
          </div>
        </div>

        <div className="mx-auto col">
          <div>
            <CrossCompanyPhoneCheck
              initialValues={initialValues}
              buttons={submitButtons}
              promoCode={submissionPromoCode}
              phoneInputClass="col-md-4 mx-auto"
            />
          </div>
        </div>
        <div className="text-center">
          <QuestionsAndContactComponent />
        </div>
      </div>
    </section>
  );
};

AppleFitnessGetStartedComponent.propTypes = {
  setErrorMessage: PropTypes.func.isRequired,
  offerId: PropTypes.number,
};
